import { motion } from "framer-motion";
import { GALLERY } from "@/lib/site-data";

export default function Gallery() {
    return (
        <section
            id="gallery"
            data-testid="gallery-section"
            className="relative py-24 lg:py-36 bg-beige/60"
        >
            <div className="max-w-7xl mx-auto px-5 lg:px-10">
                <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14 lg:mb-20">
                    <div className="max-w-xl">
                        <span className="eyebrow flex items-center gap-3">
                            <span className="w-8 h-px bg-gold" />
                            Inside Aekkarag
                        </span>
                        <h2 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl text-maroon tracking-tight leading-[1.05]">
                            A look around the{" "}
                            <em className="font-light text-gold-dark">studio</em>.
                        </h2>
                    </div>
                    <p className="text-ink-soft font-light max-w-md">
                        Calm rooms. Warm lights. Honest hands. A small visual journey through our
                        Cape Town spaces and rituals.
                    </p>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[180px] md:auto-rows-[220px] gap-3 lg:gap-4">
                    {GALLERY.map((g, i) => (
                        <motion.div
                            key={i}
                            initial={{ opacity: 0, scale: 0.96 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.6, delay: i * 0.05 }}
                            className={`relative overflow-hidden group ${
                                g.span || ""
                            }`}
                            data-testid={`gallery-item-${i}`}
                        >
                            <img
                                src={g.url}
                                alt={g.alt}
                                loading="lazy"
                                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-maroon-deep/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                            <div className="absolute bottom-3 left-3 right-3 text-cream text-xs tracking-widest uppercase opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                                {g.alt}
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
